{
  "typography": {
    "primary": "Основные стили текста",
    "secondary": "Вторичные стили текста"
  },
  "language": {
    "english": "Английский",
    "russian": "Русский"
  },
  "menu": {
    "buttons": "Кнопки",
    "timelines": "Временные шкалы",
    "users": "Пользователи",
    "vessels": "Суда"
  },
  "messages": {
    "all": "Просмотреть все сообщения",
    "new": "Новые сообщения от {name}",
    "mark_as_read": "Отметить как прочитанное"
  },
  "user": {
    "language": "Изменить язык",
    "logout": "Выйти",
    "profile": "Профиль",
    "settings": "Настройки",
    "helpAndSupport": "Помощь и поддержка",
    "account": "Аккаунт",
    "explore": "Исследовать"
  },
  "treeView": {
    "basic": "Базовый",
    "icons": "Иконки",
    "selectable": "С выбором",
    "editable": "Редактируемый",
    "advanced": "Продвинутый"
  },
  "chat": {
    "title": "Чат",
    "sendButton": "Отправить"
  },
  "spacingPlayground": {
    "value": "Значение",
    "margin": "Отступ",
    "padding": "Внутренний отступ"
  },
  "spacing": {
    "title": "Отступы"
  },
  "cards": {
    "cards": "Карточки",
    "fixed": "Фиксированные",
    "floating": "Плавающие",
    "contentText": "Уникальные полосы зебр делают их одними из самых узнаваемых животных для людей.",
    "contentTextLong": "Уникальные полосы зебр делают их одними из самых узнаваемых животных для людей. Они обитают в различных средах, таких как луга, саванны, леса, колючие кустарники, горы и прибрежные холмы. Различные антропогенные факторы оказали серьезное влияние на популяции зебр, в частности охота на шкуры и разрушение среды обитания. Зебра Греви и горная зебра находятся под угрозой исчезновения. Хотя равнинных зебр гораздо больше, один подвид, квагга, уже исчез.",
    "rowHeight": "Высота строки",
    "title": {
      "default": "По умолчанию",
      "withControls": "С элементами управления",
      "customHeader": "Пользовательский заголовок",
      "withoutHeader": "Без заголовка",
      "withImage": "С изображением",
      "withTitleOnImage": "С заголовком на изображении",
      "withCustomTitleOnImage": "С пользовательским заголовком на изображении",
      "withStripe": "С полосой",
      "withBackground": "С фоном"
    },
    "button": {
      "main": "Основная",
      "cancel": "Отмена",
      "showMore": "Показать больше",
      "readMore": "Показать больше"
    },
    "link": {
      "edit": "Редактировать",
      "setAsDefault": "Установить по умолчанию",
      "delete": "Удалить",
      "traveling": "Путешествия",
      "france": "Франция",
      "review": "Обзор",
      "feedback": "Оставить отзыв",
      "readFull": "Прочитать полную статью",
      "secondaryAction": "Вторичное действие",
      "action1": "Действие 1",
      "action2": "Действие 2"
    }
  },
  "colors": {
    "themeColors": "Цвета темы",
    "extraColors": "Дополнительные цвета",
    "gradients": {
      "basic": {
        "title": "Градиенты кнопок"
      },
      "hovered": {
        "title": "Градиенты наведенных кнопок",
        "text": "Осветление на 15% применяется к исходному стилю (градиенту или плоскому цвету) для состояния наведения."
      },
      "pressed": {
        "title": "Градиенты нажатых кнопок",
        "text": "Затемнение на 15% применяется к исходному стилю (градиенту или плоскому цвету) для нажатого состояния."
      }
    }
  },
  "tabs": {
    "alignment": "Выравнивание вкладок",
    "overflow": "Переполнение вкладок",
    "hidden": "Вкладки со скрытым слайдером",
    "grow": "Растягивающиеся вкладки"
  },
  "search": {
    "placeholder": "Поиск..."
  },
  "buttonSelect": {
    "dark": "Темный",
    "light": "Светлый"
  },
  "vuestic": {
    "search": "Поиск",
    "noOptions": "Элементы не найдены",
    "ok": "OK",
    "cancel": "Отмена",
    "uploadFile": "Загрузить файл",
    "undo": "Отменить",
    "dropzone": "Перетащите файлы сюда для загрузки",
    "fileDeleted": "Файл удален",
    "closeAlert": "закрыть оповещение",
    "backToTop": "вернуться наверх",
    "toggleDropdown": "переключить выпадающее меню",
    "carousel": "карусель",
    "goPreviousSlide": "перейти к предыдущему слайду",
    "goNextSlide": "перейти к следующему слайду",
    "goSlide": "перейти к слайду {index}",
    "slideOf": "слайд {index} из {length}",
    "close": "закрыть",
    "openColorPicker": "открыть выбор цвета",
    "colorSelection": "выбор цвета",
    "colorName": "цвет {color}",
    "decreaseCounter": "уменьшить счетчик",
    "increaseCounter": "увеличить счетчик",
    "selectAllRows": "выбрать все строки",
    "sortColumnBy": "сортировать столбец по {name}",
    "selectRowByIndex": "выбрать строку {index}",
    "resetDate": "сбросить дату",
    "nextPeriod": "следующий период",
    "switchView": "переключить вид",
    "previousPeriod": "предыдущий период",
    "removeFile": "удалить файл",
    "reset": "сбросить",
    "pagination": "пагинация",
    "goToTheFirstPage": "перейти на первую страницу",
    "goToPreviousPage": "перейти на предыдущую страницу",
    "goToSpecificPage": "перейти на страницу {page}",
    "goToSpecificPageInput": "введите номер страницы для перехода",
    "goNextPage": "перейти на следующую страницу",
    "goLastPage": "перейти на последнюю страницу",
    "currentRating": "текущий рейтинг {value} из {max}",
    "voteRating": "голосовать за рейтинг {value} из {max}",
    "optionsFilter": "фильтр опций",
    "splitPanels": "разделенные панели",
    "movePaginationLeft": "переместить пагинацию влево",
    "movePaginationRight": "переместить пагинацию вправо",
    "resetTime": "сбросить время",
    "closeToast": "закрыть уведомление",
    "selectedOption": "Выбранная опция",
    "noSelectedOption": "Опция не выбрана",
    "breadcrumbs": "хлебные крошки",
    "counterValue": "значение счетчика",
    "selectedDate": "выбранная дата",
    "selectedTime": "выбранное время",
    "progressState": "состояние прогресса",
    "color": "цвет",
    "next": "Далее",
    "back": "Назад",
    "finish": "Завершить",
    "step": "шаг",
    "progress": "прогресс",
    "loading": "Загрузка",
    "sliderValue": "Текущее значение слайдера: {value}",
    "switch": "Переключатель",
    "inputField": "Поле ввода",
    "fileTypeIncorrect": "Неверный тип файла",
    "select": "Выберите опцию"
  }
}
